// extracted by mini-css-extract-plugin
export default {"alignment":"TsBUrs"};